import toast from "react-hot-toast";
import { TOAST_CONFIG } from "./constants";

/**
 * Exibe uma notificação de sucesso
 * @param {string} message - Mensagem a ser exibida
 * @param {object} options - Opções adicionais do toast
 * @returns {string} ID do toast
 */
export const showSuccess = (message, options = {}) => {
  return toast.success(message, {
    position: TOAST_CONFIG.POSITION,
    duration: TOAST_CONFIG.DURATION,
    ...options,
  });
};

/**
 * Exibe uma notificação de erro
 * @param {string} message - Mensagem a ser exibida
 * @param {object} options - Opções adicionais do toast
 * @returns {string} ID do toast
 */
export const showError = (message, options = {}) => {
  return toast.error(message || "Ocorreu um erro. Por favor, tente novamente.", {
    position: TOAST_CONFIG.POSITION,
    duration: TOAST_CONFIG.DURATION,
    ...options,
  });
};

/**
 * Exibe uma notificação de informação
 * @param {string} message - Mensagem a ser exibida
 * @param {object} options - Opções adicionais do toast
 * @returns {string} ID do toast
 */
export const showInfo = (message, options = {}) => {
  return toast(message, {
    position: TOAST_CONFIG.POSITION,
    duration: TOAST_CONFIG.DURATION,
    icon: "ℹ️",
    ...options,
  });
};

/**
 * Exibe uma notificação de carregamento
 * @param {string} message - Mensagem a ser exibida
 * @returns {string} ID do toast
 */
export const showLoading = (message = "Carregando...") => {
  return toast.loading(message, {
    position: TOAST_CONFIG.POSITION,
  });
};

/**
 * Remove uma notificação de carregamento e exibe sucesso/erro
 * @param {string} toastId - ID do toast de carregamento
 * @param {string} message - Mensagem final
 * @param {'success'|'error'} type - Tipo da notificação final
 */
export const dismissLoading = ( message, type = "success") => {
  if (type === "success") {
    showSuccess(message);
  } else {
    showError(message);
  }
};

